import { render, staticRenderFns } from "./MonographForm.vue?vue&type=template&id=3b8d170a&scoped=true"
import script from "./MonographForm.vue?vue&type=script&lang=js"
export * from "./MonographForm.vue?vue&type=script&lang=js"
import style0 from "./MonographForm.vue?vue&type=style&index=0&id=3b8d170a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d170a",
  null
  
)

export default component.exports